import { useState, useEffect, useRef } from "react"

const MAX_RESULTADOS = 30

const normalizar = (s = "") => s.toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "").trim()

function BuscadorProducto({ catalogo, value, onChange }) {
  const producto = catalogo.find(p => String(p.id) === String(value)) || null
  const [query, setQuery]       = useState("")
  const [abierto, setAbierto]   = useState(false)
  const [resaltado, setResaltado] = useState(0)
  const ref                     = useRef(null)

  const q = normalizar(query)
  // Primero los que coinciden por código; después los que coinciden solo por descripción o marca
  const porCodigo = q ? catalogo.filter(p => normalizar(p.codigo).includes(q)) : []
  const porTexto  = q ? catalogo.filter(p =>
    !normalizar(p.codigo).includes(q) &&
    (normalizar(p.descripcion).includes(q) || normalizar(p.marca).includes(q))
  ) : []
  const filtrados = [...porCodigo, ...porTexto].slice(0, MAX_RESULTADOS)

  useEffect(() => {
    const cerrar = (e) => { if (ref.current && !ref.current.contains(e.target)) setAbierto(false) }
    document.addEventListener("mousedown", cerrar)
    return () => document.removeEventListener("mousedown", cerrar)
  }, [])

  const handleSelect = (p) => {
    onChange(String(p.id))
    setQuery("")
    setAbierto(false)
  }

  const handleInputChange = (e) => {
    setQuery(e.target.value)
    setResaltado(0)
    setAbierto(true)
    if (value) onChange("")
  }

  const handleKeyDown = (e) => {
    if (!abierto || filtrados.length === 0) return
    if (e.key === "ArrowDown") { e.preventDefault(); setResaltado(i => Math.min(i + 1, filtrados.length - 1)) }
    else if (e.key === "ArrowUp") { e.preventDefault(); setResaltado(i => Math.max(i - 1, 0)) }
    else if (e.key === "Enter") { e.preventDefault(); handleSelect(filtrados[resaltado]) }
    else if (e.key === "Escape") { setAbierto(false) }
  }

  const displayValue = producto && !abierto
    ? `${producto.codigo} · ${producto.descripcion}`
    : query

  return (
    <div className="buscadorProducto" ref={ref}>
      <input
        type="text"
        placeholder="escribí el código del producto..."
        value={displayValue}
        onChange={handleInputChange}
        onFocus={() => { setAbierto(true); if (producto) setQuery("") }}
        onKeyDown={handleKeyDown}
        autoComplete="off"
      />
      {abierto && q && (
        <div className="buscadorProductoDropdown">
          {filtrados.length === 0 ? (
            <div className="buscadorProductoItem buscadorProductoItem--vacio">ningún producto coincide con "{query}"</div>
          ) : (
            filtrados.map((p, i) => (
              <div
                key={p.id}
                className={`buscadorProductoItem${i === resaltado ? " buscadorProductoItem--activo" : ""}`}
                onMouseDown={() => handleSelect(p)}
                onMouseEnter={() => setResaltado(i)}
              >
                <span className="buscadorProductoCodigo">{p.codigo}</span>
                <span className="buscadorProductoDesc">{p.descripcion}</span>
                <span className="buscadorProductoMarca">{p.marca}</span>
              </div>
            ))
          )}
        </div>
      )}
    </div>
  )
}

export default BuscadorProducto
